import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./views/authentication/Login";
import Dashboard from "./views/layout/Dashboard";
import Reorder from "./components/Pages/Reorder";
import PrivateRoute from "./routes/PrivateRoute"; // import here

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />

      <Route
        path="/salesorder/:id"
        element={
          <PrivateRoute>
            <Reorder />
          </PrivateRoute>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
